module.exports = __webpack_public_path__ + "media/home-questions.29a24e60.mp4";